module.exports = __webpack_public_path__ + "img/paesaggio 2_med.47628c77.jpeg";